module.exports = __webpack_public_path__ + "static/media/Mobleapp.26c265b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/oldMunafaMart/Mobleapp.jpg
// module id = 410
// module chunks = 0